<template>
  <div class="wrap">
    <div class="form_box">
      <!-- <div class="head_img">
        <img class="logo" src="@/assets/images/logo_new.png" alt="" />
      </div> -->
      <div class="form">
        <el-form :model="params" :rules="rules" ref="ruleForm">
          <el-form-item prop="schoolId">
            <el-select v-model="params.schoolId" placeholder="请选择学校">
              <el-option
                v-for="item in schoolList"
                :key="item.schoolId"
                :label="item.name"
                :value="item.schoolId"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="username">
            <el-input
              class="input"
              placeholder="请输入手机号"
              v-model.number="params.username"
              :maxlength="11"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-user"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              class="input"
              placeholder="请输入密码"
              v-model="params.password"
              show-password
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-lock"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              class="input"
              maxlength="4"
              placeholder="请输入验证码"
              v-model="params.code"
            >
              <img
                slot="suffix"
                class="captcha"
                :src="codeImg"
                @click="getCaptcha"
              />
            </el-input>
          </el-form-item>
        </el-form>

        <el-button
          class="register_btn"
          type="primary"
          @click="handleRegister('ruleForm')"
          :loading="loading"
          >{{ loading ? "注册中..." : "注 册" }}</el-button
        >
        <p class="go_register">
          已有账号，
          <span @click="$router.push('/login')">去登录</span>
        </p>
      </div>
    </div>
    <!-- <div class="bottom_nav">
      <div class="nav">
        <span
          class="nav_item"
          v-for="item in navs"
          :key="item.id"
          @click="$router.push(item.name)"
          >{{ item.label }}</span
        >
      </div>
      <p>copyright©2021厦门易普道信息科技有限公司</p>
    </div> -->
  </div>
</template>

<script>
import { register, captcha, schoolList } from "@/api/login";
export default {
  name: "register",
  data() {
    var checkUser = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字"));
      }
      if (String(value).length < 11) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      navs: [
        {
          id: "1",
          label: "首页",
          name: "home",
        },
        {
          id: "2",
          label: "隐私",
          name: "home",
        },
        {
          id: "3",
          label: "条款",
          name: "home",
        },
      ],
      schoolList: [],
      params: {
        schoolId: null,
        username: "",
        password: "",
        code: "",
        codeId: "",
      },
      rules: {
        schoolId: {
          required: true,
          message: "请选择学校",
          trigger: "blur",
        },
        username: { validator: checkUser, trigger: "blur" },
        password: {
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },
        code: {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      },
      remember: false,
      codeImg: "",
      loading: false,
    };
  },
  created() {
    this.getCaptcha();
    this.getSchoolList();
  },
  methods: {
    //   学校列表
    getSchoolList() {
      schoolList().then((res) => {
        if (res.code == 0) {
          this.schoolList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 图形码
    getCaptcha() {
      captcha().then((res) => {
        if (res.code == 0) {
          this.codeImg = "data:image/gif;base64," + res.data.codeImg;
          this.params.codeId = res.data.codeId;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          register(this.params).then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.$message.success("注册成功");
              this.$router.push("/login");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  padding-top: 120px;
  padding-bottom: 40px;
  min-height: 100vh;
  background-image: url("../../assets/images/bg.jpg");
  background-size: cover;

  .form_box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 30px 45px;
    width: 450px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.31);

    .head_img {
      margin-bottom: 30px;
      text-align: center;

      .logo {
        width: 230px;
      }
    }

    .form {
      ::v-deep .input {
        // .el-input__inner {
        //   height: 43px;
        // }
        .el-input__suffix {
          right: 0;
        }
      }

      ::v-deep .el-select {
        width: 100%;
        .el-input__inner {
          height: 40px;
        }
      }

      .captcha {
        height: 40px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
      .register_btn {
        margin-top: 10px;
        margin-bottom: 20px;
        width: 100%;
        font-size: 18px;
      }

      .go_register {
        text-align: center;

        span {
          color: #1890ff;
          cursor: pointer;
        }
      }
    }
  }

  .bottom_nav {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #fff;

    .nav {
      margin-bottom: 20px;

      .nav_item {
        display: inline-block;
        margin: 0 32px;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          color: #dbdbdb;
        }
      }
    }
  }
}
</style>